var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Mobility Status")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [
              _vm._v(" " + _vm._s(_vm.data.mobility_status) + " "),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                [
                  _c("li", [
                    _vm._v(
                      "Level: " + _vm._s(_vm.data.mobility_level || "N/A")
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Notes: " + _vm._s(_vm.data.mobility_notes || "N/A")
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Communication Ability")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [
              _vm._v(
                " " + _vm._s(_vm.data.communication_ability || "N/A") + " "
              ),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "Others: " + _vm._s(_vm.data.communication_others || "N/A")
                ),
              ]),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "Notes: " + _vm._s(_vm.data.communication_notes || "N/A")
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Cognitive Status")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                [
                  _c("li", [
                    _vm._v(
                      "Concerns: " +
                        _vm._s(_vm.data.cognitive_concerns || "N/A")
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Notes: " + _vm._s(_vm.data.cognitive_notes || "N/A")
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Functional Assessment"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }